import { useTranslation } from "react-i18next";
import React from "react";
import { Row, Col } from "react-bootstrap";

import DateInput from "@components/forms/DateInput";
import ISelect from "@components/forms/ISelect";
import { Search } from "lucide-react";
import { Config } from "@config/config";

function NewInvoiceForm(props) {
  const { t } = useTranslation();
  const config = new Config(t);

  return (
    <div className="p-2">
      <Row className="my-3">
        <Col md="12" className="my-3">
          <ISelect
            id="service"
            name="service"
            label={t("service")}
            value={props.selectedService}
            handleChange={props.setSelectedService}
            data={config.serviceOptions()}
          />
        </Col>
        <Col md="12" className="my-3">
          <DateInput
            leftLabel={t("from")}
            rightLabel={t("to")}
            onDateChange={props.onChangeDate}
            dateFrom={props.dateFrom}
            dateTo={props.dateTo}
          />
        </Col>

        <Col md="12" className="my-3">
          <button
            className="btn-blue btn-outline-blue w-100 p-3"
            onClick={() => props.loadData()}
          >
            <Search size={25} strokeWidth={1.2} /> {t("search")}
          </button>
        </Col>
      </Row>
    </div>
  );
}
export default NewInvoiceForm;
